import { create } from 'zustand'

export interface ModalRemoveItemListState {
    modalRemoveItemList: {
        isOpen: boolean
        onClose: () => void
        onConfirm: () => void
        propertyAddress?: string
        isLoading?: boolean
    }
    setRemoveItemList: (removeItemList: ModalRemoveItemListState["modalRemoveItemList"]) => void
    onClose: () => void
    setIsLoading: (isLoading: boolean) => void
}

const initialState = {
    modalRemoveItemList: {
        isOpen: false,
        propertyAddress: '',
        isLoading: false,
        onClose: () => {},
        onConfirm: () => {}
    },
}

export const useModalRemoveItemListStore = create<ModalRemoveItemListState>()((set, get) => ({
  ...initialState,
  setRemoveItemList: (removeItemList) => set({ modalRemoveItemList: removeItemList }),
  setIsLoading: (isLoading) => {
    set({ modalRemoveItemList: { ...get().modalRemoveItemList, isLoading } })
  },
  onClose: () => {
    set({ modalRemoveItemList: { ...get().modalRemoveItemList, isOpen: false } })
  }
}))
